import { Button, rem, useMantineTheme } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

interface MobileBackButtonProps {
    shouldShow: boolean;
    onBack: () => void;
    backText?: string;
}

export const MobileBackButton = ({ shouldShow, onBack, backText }: MobileBackButtonProps) => {
    const theme = useMantineTheme();

    if (!shouldShow) return null;

    return (
        <Button
            variant="subtle"
            size="sm"
            leftSection={<IconArrowLeft size={16} />}
            onClick={onBack}
            style={{
                padding: `${rem(8)} ${rem(12)}`,
                height: 'auto',
                fontWeight: 500,
                color: theme.colors.blue[6]
            }}
        >
            {backText}
        </Button>
    );
};
